const locales = [
  { label: 'ar-SA', value: 'ar-SA' },
  { label: 'cs-CZ', value: 'cs-CZ' },
  { label: 'da-DK', value: 'da-DK' },
  { label: 'de-DE', value: 'de-DE' },
  { label: 'el-GR', value: 'el-GR' },
  { label: 'en-AU', value: 'en-AU' },
  { label: 'en-CA', value: 'en-CA' },
  { label: 'en-GB', value: 'en-GB' },
  { label: 'en', value: 'en', isDefault: true },
  { label: 'en-US', value: 'en-US', mappedTo: 'en' },
  { label: 'es-ES', value: 'es-ES' },
  { label: 'es-US', value: 'es-US', mappedTo: 'es-MX' },
  { label: 'es-MX', value: 'es-MX' },
  { label: 'fi-FI', value: 'fi-FI' },
  { label: 'fr-CA', value: 'fr-CA' },
  { label: 'fr-FR', value: 'fr-FR' },
  { label: 'he-IL', value: 'he-IL' },
  { label: 'hi-IN', value: 'hi-IN' },
  { label: 'hu-HU', value: 'hu-HU' },
  { label: 'id-ID', value: 'id-ID' },
  { label: 'it-IT', value: 'it-IT' },
  { label: 'ja-JP', value: 'ja-JP' },
  { label: 'ko-KR', value: 'ko-KR' },
  { label: 'ms-MY', value: 'ms-MY' },
  { label: 'nb-NO', value: 'nb-NO' },
  { label: 'nl-NL', value: 'nl-NL' },
  { label: 'pl-PL', value: 'pl-PL' },
  { label: 'pt-BR', value: 'pt-BR' },
  { label: 'pt-PT', value: 'pt-PT' },
  { label: 'ro-RO', value: 'ro-RO' },
  { label: 'ru-RU', value: 'ru-RU' },
  { label: 'sk-SK', value: 'sk-SK' },
  { label: 'sv-SE', value: 'sv-SE' },
  { label: 'th-TH', value: 'th-TH' },
  { label: 'tl-PH', value: 'tl-PH' },
  { label: 'tr-TR', value: 'tr-TR' },
  { label: 'vi-VN', value: 'vi-VN' },
  { label: 'zh-CN', value: 'zh-CN' },
  { label: 'zh-HK', value: 'zh-HK', iso15924Tag: 'zh-Hant-HK' },
  {
    label: 'zh-TW',
    value: 'zh-TW',
    mappedTo: 'zh-HK',
    iso15924Tag: 'zh-Hant-TW',
  },
  { label: 'zh-SG', value: 'zh-SG', mappedTo: 'zh-CN' },
]

// Unfortunately, we still have to use moment for locale support because react-dates depend on it. :(
require('moment/locale/cs')
require('moment/locale/da')
require('moment/locale/de')
require('moment/locale/el')
require('moment/locale/es')
require('moment/locale/fi')
require('moment/locale/fr')
require('moment/locale/hi')
require('moment/locale/hu')
require('moment/locale/id')
require('moment/locale/it')
require('moment/locale/ja')
require('moment/locale/ko')
require('moment/locale/ms')
require('moment/locale/nb')
require('moment/locale/nl')
require('moment/locale/pl')
require('moment/locale/pt')
require('moment/locale/ru')
require('moment/locale/sk')
require('moment/locale/sv')
require('moment/locale/th')
require('moment/locale/tl-ph')
require('moment/locale/tr')
require('moment/locale/vi')
require('moment/locale/zh-cn')
require('moment/locale/zh-hk')
require('moment').locale('en')

export { default as sharedMessages } from './shared.messages'

export function getLocaleCode(requestedLocale: string): string {
  const data = locales.find((x) => x.value === requestedLocale)
  return data ? data.mappedTo || data.value : requestedLocale
}

export function getIso15924Tag(requestedLocale: string): string {
  const data = locales.find((x) => x.value === requestedLocale)
  return data ? data.iso15924Tag || data.value : requestedLocale
}

export default locales
